import gsap from 'gsap';

const els = {
    $navigators: () => $('[data-photo-collections-navigator]'),
    $home: ($navigator) => $navigator.find('[data-photo-collections-navigator-home]'),
    $collectionButtons: ($navigator) => $navigator.find('[data-photo-collections-navigator-collection-button]'),
    $collections: ($navigator) => $navigator.find('[data-photo-collections-navigator-collection]'),
    $homeButtons: ($navigator) => $navigator.find('[data-photo-collections-navigator-home-button]'),
    $navigatorForCollection: ($collection) => $collection.parents('[data-photo-collections-navigator]'),
    $visibleCollection: ($navigator) => $navigator.find('[data-photo-collections-navigator-collection]:visible'),
};

let navigating = false;

const goToCollection = async ($collection) => {
    if (navigating) {
        return;
    }

    navigating = true;

    const $navigator = els.$navigatorForCollection($collection);
    const $home = els.$home($navigator);
    const timeline = gsap.timeline({
        paused: true,
    });

    timeline.set(
        $home,
        {
            position: 'absolute',
            top: 0,
            left: 0,
        }
    );

    timeline.fromTo(
        $navigator,
        { height: $home.outerHeight() },
        { height: $collection.outerHeight() }
    );

    timeline.to($home, { autoAlpha: 0 }, '<');

    timeline.to($collection, { autoAlpha: 1 }, '<');

    timeline.set($collection, { position: 'relative' });

    timeline.set($navigator, { clearProps: 'height' });

    await timeline.play();

    navigating = false;
};

const goHome = async ($navigator) => {
    if (navigating) {
        return;
    }

    navigating = true;

    const $home = els.$home($navigator);
    const $collection = els.$visibleCollection($navigator);
    const timeline = gsap.timeline({
        paused: true,
    });

    timeline.set($collection, { clearProps: 'position' });

    timeline.fromTo(
        $navigator,
        { height: $collection.outerHeight() },
        { height: $home.outerHeight() }
    );

    timeline.to($collection, { autoAlpha: 0 }, '<');

    timeline.to($home, { autoAlpha: 1 }, '<');

    timeline.set($home, { clearProps: 'position' });

    timeline.set($navigator, { clearProps: 'height' });

    await timeline.play();

    navigating = false;
};

const initializeNavigator = (navigator) => {
    const $navigator = $(navigator);
    const $collectionButtons = els.$collectionButtons($navigator);
    const $collections = els.$collections($navigator);
    const $homeButtons = els.$homeButtons($navigator);

    $collectionButtons.on('click', (event) => {
        const $button = $(event.currentTarget);
        const index = $button.index();
        const $collection = $collections.eq(index);

        goToCollection($collection);
    });

    $homeButtons.on('click', () => {
        goHome($navigator);
    });
};

const initialize = () => {
    els.$navigators().each((_, navigator) => {
        initializeNavigator(navigator);
    });
};

export default {
    initialize,
};

